import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  cartList: [],
};

const sliceCart = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCartList: (state, action) => {
      state.cartList = action.payload;
    },
    addToCart: (state, action) => {
      const product = action.payload;
      const existingProduct = state.cartList.find(
        (item) => item.ItmCd === product.ItmCd
      );
      if (existingProduct) {
        existingProduct.qty += 1;
        existingProduct.Taxable = existingProduct.RSP * existingProduct.qty;
        existingProduct.NetAmount =
          existingProduct.VATRSP * existingProduct.qty;
      } else {
        state.cartList.push({
          ...product,
          qty: 1,
          Taxable: product.RSP * 1,
          NetAmount: product.VATRSP * 1,
        });
      }
    },
    incrementQty: (state, action) => {
      const productId = action.payload;
      const product = state.cartList.find((item) => item.ItmCd === productId);
      if (product) {
        product.qty += 1;
        product.Taxable = product.RSP * product.qty;
        product.NetAmount = product.VATRSP * product.qty;
      }
    },
    decrementQty: (state, action) => {
      const productId = action.payload;
      const product = state.cartList.find((item) => item.ItmCd === productId);
      if (product) {
        if (product.qty > 1) {
          product.qty -= 1;
          product.Taxable = product.RSP * product.qty;
          product.NetAmount = product.VATRSP * product.qty;
        } else {
          state.cartList = state.cartList.filter(
            (item) => item.ItmCd !== productId
          );
        }
      }
    },
  },
});

export const { addToCart, incrementQty, decrementQty, setCartList } =
  sliceCart.actions;
export default sliceCart.reducer;
